import { z } from 'zod';

import { ROLES } from '@/types';

import { isPasswordValid } from './password-rules';

// Canonical role set now lives in the `types` layer (see src/types/roles.ts);
// re-exported here for back-compat with existing auth-feature imports.
export const ADMIN_ROLES = ROLES;

export const phoneSchema = z.string().regex(/^\d{10}$/, 'Enter a valid 10-digit US phone number');
export const otpSchema = z.string().regex(/^\d{6}$/, 'Enter the 6-digit code');

export const userSchema = z.object({
  id: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  role: z.enum(ADMIN_ROLES),
});

export const loginPasswordSchema = z.object({
  phone: phoneSchema,
  password: z.string().min(1, 'Password is required'),
  rememberMe: z.boolean().optional().default(false),
});

export const sendOtpSchema = z.object({
  phone: phoneSchema,
  rememberMe: z.boolean().optional().default(false),
});

export const newPasswordSchema = z
  .object({
    newPassword: z.string().refine(isPasswordValid, 'Password does not meet the requirements'),
    confirmPassword: z.string(),
  })
  .refine((v) => v.newPassword === v.confirmPassword, {
    message: 'Passwords do not match.',
    path: ['confirmPassword'],
  });
